module.exports = __webpack_public_path__ + "static/media/diamondCertificateImage1.24716caf.jpg";